export default '/vercel/path0/webapp/node_modules/libsodium-sumo/dist/modules-sumo'